var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddressCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.602,
    height: 14.468,
    viewBox: "0 0 18.602 14.468",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-address-card",
    "data-name": "Icon awesome-address-card",
    d: "M17.052,2.25H1.55A1.551,1.551,0,0,0,0,3.8V15.168a1.551,1.551,0,0,0,1.55,1.55h15.5a1.551,1.551,0,0,0,1.55-1.55V3.8A1.551,1.551,0,0,0,17.052,2.25ZM5.684,5.35A2.067,2.067,0,1,1,3.617,7.417,2.069,2.069,0,0,1,5.684,5.35ZM9.3,13a.677.677,0,0,1-.723.62H2.79A.677.677,0,0,1,2.067,13v-.62a2.034,2.034,0,0,1,2.17-1.86H4.4a3.326,3.326,0,0,0,2.571,0h.161a2.034,2.034,0,0,1,2.17,1.86Zm7.234-1.705a.259.259,0,0,1-.258.258H11.626a.259.259,0,0,1-.258-.258v-.517a.259.259,0,0,1,.258-.258h4.651a.259.259,0,0,1,.258.258Zm0-2.067a.259.259,0,0,1-.258.258H11.626a.259.259,0,0,1-.258-.258V8.709a.259.259,0,0,1,.258-.258h4.651a.259.259,0,0,1,.258.258Zm0-2.067a.259.259,0,0,1-.258.258H11.626a.259.259,0,0,1-.258-.258V6.642a.259.259,0,0,1,.258-.258h4.651a.259.259,0,0,1,.258.258Z",
    transform: "translate(0 -2.25)",
    fill: "#a1a3ef"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddressCard);
export default __webpack_public_path__ + "static/media/Address Card.a339888fc5e841af0cd9fabd1af90569.svg";
export { ForwardRef as ReactComponent };